class CurrentUser {
  public id: string;
  public username: string;
  public email: string;
  public profileImageUrl: string;

  constructor({
    id,
    username,
    email,
    profileImageUrl,
  }: {
    id: string;
    username: string;
    email: string;
    profileImageUrl: string;
  }) {
    this.id = id;
    this.username = username;
    this.email = email;
    this.profileImageUrl = profileImageUrl;
  }
}

export default CurrentUser;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/entity/CurrentUser.ts